import { call, fork, put, select, takeLatest } from 'redux-saga/effects';
import { AxiosResponse, AxiosError } from 'axios';
import { SagaIterator } from 'redux-saga';

// Global Utils
// @ts-ignore
import axiosPoll from 'utils/axiosPoll';

// Local Constants
import {
    SPRAY_EVENTS_FOR_SUBMISSION_LOAD_REQUESTED
} from './constants';

// Local Actions
import {
    succeededLoadSprayEventsForSubmission,
    failedLoadSprayEventsForSubmission
} from './actions';

// Local Selectors
import { selectLoadSprayEventsForSubmissionParams } from './params';

// Environment
const { REACT_APP_API_URL } = process.env;

export function* loadSprayEventsForSubmissionSucceeded(
    response: AxiosResponse
): SagaIterator {
    // Succeeded Load Spray Events
    yield put(succeededLoadSprayEventsForSubmission(response));
}

export function* loadSprayEventsForSubmissionFailed(error: AxiosError): SagaIterator {
    yield put(failedLoadSprayEventsForSubmission(error));
}

export function* loadSprayEventsForSubmission(): SagaIterator {
    // Select params
    const params = yield select(selectLoadSprayEventsForSubmissionParams);

    yield call(axiosPoll, {
        config: {
            method: 'GET',
            url: `${REACT_APP_API_URL}/v1/Events`,
            params
        },
        succeeded: loadSprayEventsForSubmissionSucceeded,
        failed: loadSprayEventsForSubmissionFailed
    });
}

export function* watchSprayEventsForSubmissionLoadRequested(): SagaIterator {
    yield takeLatest(SPRAY_EVENTS_FOR_SUBMISSION_LOAD_REQUESTED, loadSprayEventsForSubmission);
}

export default function* sprayEventsForSubmissionSagas(): SagaIterator {
    yield fork(watchSprayEventsForSubmissionLoadRequested);
}
